import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

const S3Plugin = React.lazy(() => importFromS3('tcc-data-hub'));

export const DataHubPluginContainer: React.FC<{ operationsSelected: Operation[] }> = ({ operationsSelected }) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags['web.dataHub.module-federation'];

  const DataHubPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('dataHub/DataHub'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  return <DataHubPlugin
    operationsSelected={operationsSelected}
    shouldRenderFarmerNav={false}
  />;
};
